import {
  Box,
  Typography,
  Container,
  useTheme,
  Divider,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  Chip,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function PrivacyPolicy() {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const currentPolicy = t("privacyPolicy", { returnObjects: true });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 4, sm: 6 },
        backgroundColor: "#f5f7fa",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{ p: { xs: 3, sm: 4 }, backgroundColor: "#fff", borderRadius: 3 }}
        >
          {/* Header */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              {t("privacyPolicy.title")}
            </Typography>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ color: theme.palette.text.secondary }}
            >
              {t("privacyPolicy.appName")} — {t("privacyPolicy.contact")}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Intro */}
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            {t("privacyPolicy.intro")}
          </Typography>

          {/* Sections */}
          {currentPolicy.sections.map((section, index) => (
            <Box key={index} sx={{ mb: 4 }}>
              {/* Title */}
              <Box sx={{ mb: 1 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: theme.palette.primary.main }}
                >
                  {section.title}
                  {section.tag && (
                    <Chip
                      label={section.tag}
                      size="small"
                      color="primary"
                      sx={{ ml: 1 }}
                    />
                  )}
                </Typography>
                {section.subtitle && (
                  <Typography
                    variant="body2"
                    sx={{ mt: 0.5, color: theme.palette.text.secondary }}
                  >
                    {section.subtitle}
                  </Typography>
                )}
              </Box>

              {/* Content */}
              <Box sx={{ pl: isMobile ? 0 : 2 }}>
                {section.type === "list" ? (
                  <List dense sx={{ py: 0 }}>
                    {section.items.map((item, itemIndex) => (
                      <ListItem key={itemIndex} sx={{ px: 0, py: 1 }}>
                        <ListItemText
                          primary={
                            item.title && (
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 500 }}
                              >
                                {item.title}
                              </Typography>
                            )
                          }
                          secondary={item.content}
                          secondaryTypographyProps={{
                            variant: "body2",
                            color: "text.secondary",
                          }}
                          sx={{ m: 0 }}
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  section.items.map((item, itemIndex) => (
                    <Typography
                      key={itemIndex}
                      variant="body1"
                      paragraph
                      sx={{
                        ml: item.startsWith("-") ? 2 : 0,
                        color: theme.palette.text.secondary,
                        fontSize: isMobile ? "0.875rem" : "1rem",
                      }}
                    >
                      {item}
                    </Typography>
                  ))
                )}
              </Box>
            </Box>
          ))}
        </Paper>
      </Container>
    </Box>
  );
}

export default PrivacyPolicy;
